import { getDeviationFraction } from '@ovComponents/4-module/widgets/portfolio/components/utils';

/** Same math as SecurityTableRow deviation column. */
export const resolvePortfolioWidgetDeviation = ({
  valueCents,
  expectedValueCents,
  pendingTradesCents = 0,
}: {
  valueCents: number;
  expectedValueCents: number;
  pendingTradesCents?: number;
}): { deviationCents: number; deviationPercentage: number } => {
  const deviationCents = valueCents + pendingTradesCents - expectedValueCents;
  const deviationPercentage = getDeviationFraction(
    deviationCents,
    expectedValueCents,
  );

  return { deviationCents, deviationPercentage };
};
